import $ from "jquery";
import { FieldTypes } from "../../types";

/* eslint-disable */
registerNS("ep.forms.utility");
registerNS("ep.forms.fieldTypes");

ep.forms.fieldTypes = FieldTypes;

ep.forms.convertibleFieldTypes = {
    Text: true,
    TextArea: true,
    FileUpload: true,
    Dropdown: true,
    RadioList: true,
    CheckList: true,
    Date: true,
    Paragraph:false,
    Heading:false,
    Separator:false
};

ep.forms.formStates = {
  Draft:'Draft',
  Publish:'Publish',
  Archive: 'Archive'
};

ep.forms.entityConversionType = {
  Project: 'Project',
  Task: 'Task',
  Issue: 'Issue',
  Request: 'Request'
};

ep.forms.formLayoutModelWrapper = function (fieldItems, mappingOptions) {
    var Items = [];
    var Handlers = [];
    var MappingOptions = {};

    var Types = {};
    this.getFormItems = function () {
        return Items;
    };

    this.getTypes = function () {
        return ep.forms.fieldTypes;
    };

    this.removeItem = function (id) {
        $.each(Items, function (index, value) {
            if (value && value.Id == id) {
                Items.splice(index, 1);
                return true;
            }
        });

        this.triggerChanged();
    };

    this.replaceItemLocation = function (newIndices) {
        var compare = function (a, b) {
            return newIndices[a.Id] - newIndices[b.Id];
        };

        Items.sort(compare);

        this.triggerChanged();
    },

    this.addItem = function (obj) {
        var newObj = {
            Id: obj.Id, // For client side purposes.
            Label: obj.Label,
            Type: obj.Type,
            Items: obj.Items,
            Required: false,
            FieldID: obj.FieldID,
            IsConvertible: ep.forms.convertibleFieldTypes[obj.Type],
            IsEmailTargetField: obj.IsEmailTargetField
    };

        if (newObj.IsConvertible) {
            newObj.ProjectTargetField = this._getDefaultField(obj.Type, ep.forms.entityConversionType.Project);
            newObj.TaskTargetField = this._getDefaultField(obj.Type, ep.forms.entityConversionType.Task);
            newObj.IssueTargetField = this._getDefaultField(obj.Type, ep.forms.entityConversionType.Issue);
            newObj.RequestTargetField = this._getDefaultField(obj.Type, ep.forms.entityConversionType.Request);
        }

        Items.push(newObj);

        this.triggerChanged();
    };

    this.setFormItem = function (item) {
        $.each(Items, function (index, value) {
            if (item.Id == value.Id) {
                Items[index] = item;
                return false;
            }
        });
    };

    this.getFormItemById = function (id) {
        var hash = this.getFormItems();
        var item;
        $.each(hash, function (index, value) {
            if (id == value.Id)
                item = value;
        });
        return item;
    };

    this.generateId = function () {
        var el = this.getFormItems();
        var newId = el ? 0 : el[0].Id;
        if (el) {
            $.each(el, function (i, element) {
                newId = element.Id > newId ? element.Id + 1 : newId + 1;
            });
        }
        return newId;
    };

    this.triggerChanged = function () {
        $.each(Handlers, function (i, handler) {
            handler();
        });
    };

    this.addOnChange = function (handler) {
        Handlers.push(handler);
    };

    this.removeOnChange = function (handler) {
        $.each(Handlers, function (index, value) {
            if (value && value == handler) {
                Handlers.splice(index, 1);
                return;
            }
        });
    };

    this.getMapingTypeOptions = function (type, entityConversionType) {
        var options = {};

        if (entityConversionType == ep.forms.entityConversionType.Project) {
            options = MappingOptions.Project[type];
        }

        if (entityConversionType == ep.forms.entityConversionType.Task) {
            options = MappingOptions.Task[type];
        }

        if (entityConversionType == ep.forms.entityConversionType.Issue) {
            options = MappingOptions.Issue[type];
        }

        if (entityConversionType == ep.forms.entityConversionType.Request) {
            options = MappingOptions.Request[type];
        }

        return options;
    };

    this.updateMappingOptions = function (entity, mappingOptions) {
        MappingOptions[entity] = mappingOptions;
    };

    this._getDefaultField = function (type, entityConversionType) {
        var options = this.getMapingTypeOptions(type, entityConversionType);

        var defaultOption = $.grep(options, function (item, index) {
            return item.IsDefault;
        })[0];

        return defaultOption.FieldName;
    };

    this._fillItems = function () {
        MappingOptions = mappingOptions;

        var index = 0;
        if (fieldItems != null) {
            $.each(fieldItems, function (i, element) {
                if (element.Id == undefined) {
                    element.Id = index++;
                }

                Items.push(element);
            });
        }
    };

    this._fillItems();
};

ep.forms.utility =
{
    itemsToText: function (items) {
        var text = "";
        if (items != null) {
            $.each(items, function (index, value) {
                text = text + value + "\n";
            });
        }
        return text;
    },

    textToItems: function (text) {
        var splitItems = text.replace("\\n", "\n").split('\n');
        var items = [];
        $.each(splitItems, function (index, value) {
            if (value.length != 0) {
                items.push(ep.common.trim(value));
            }

        });
        return items;
    },

    closePopups: function () {
        $('body').trigger('closePopup');
    }
};

/* eslint-enable */
